import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import Button from 'components/Button'
import { _, colors } from 'utils'
import { addModal } from 'features/modals/modalSlice'
import CreateSpace from '../CreateSpace'

const S = {
    Wrapper: styled.div`
        position: relative;
        margin-top: -55px;
        background-color: #f9f9f9;
    `,
    Header: styled.h1`
        margin-bottom: 32px;
        font-weight: bold;
        font-size: 30px;
        color: ${colors.darkOpacity(0.9)};
    `
}

const NoSpace = ({ fetchData }: { fetchData: () => Promise<void> }) => {
    const dispatch = useDispatch()
    const showAddModal = () => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <CreateSpace close={close} onSubmitted={fetchData} minOrder={0} />
            ),
            shouldNotWrap: true
        }))
    }

    return (
        <S.Wrapper>
            <S.Header>
                {_('space_overview.no_space_header')}
            </S.Header>
            <Button style={{ backgroundColor: colors.keppel }} onClick={showAddModal}>
                {_('space_overview.create_new_space')}
            </Button>
        </S.Wrapper>
    )
}

export default NoSpace
